import { render, staticRenderFns } from "./Items.html?vue&type=template&id=528b5ad6&external"
import script from "./Items.js?vue&type=script&lang=js&external"
export * from "./Items.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports